import {
    SET_CURRENT_USER_CLASS_LIST,
    ADD_TO_CURRENT_USER_CLASS_LIST,
    REMOVE_TO_CURRENT_USER_CLASS_LIST,
    SET_SELECTED_DAY
} from "../actions/current_userActions";


export interface currentUserReducerState {
    classList: [],
    selectedDay: any
}

const initialState: currentUserReducerState = {
    classList: [],
    selectedDay: null
}

export const current_userReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SELECTED_DAY:
            return {
                ...state,
                selectedDay: action.value
            }
        case SET_CURRENT_USER_CLASS_LIST:
            return {
                ...state,
                classList: action.value
            }
        case ADD_TO_CURRENT_USER_CLASS_LIST:
            const push = (value: any) => {
                const newClassList: string[] = state.classList.slice();
                newClassList.push(value);
                return newClassList;
            }
            return {
                ...state,
                classList: push(action.value)
            }
        case REMOVE_TO_CURRENT_USER_CLASS_LIST:
            const splice = (value: string) => {
                const newClassList: any[] = state.classList.slice();
                const index = newClassList.findIndex(x => value === x._id);
                if (index > -1) {
                    newClassList.splice(index, 1);
                }
                return newClassList;
            }
            return {
                ...state,
                classList: splice(action.value)
            }
        default:
            return state;
    }
}


